import { Navigate } from "react-router-dom";
import CAN from "../../casl/can";
import { Action, Resource } from "../../casl/constants";

export const USER_TYPE = {
    "INTERNAL":"internal",
    "CUSTOMER":"customer"
}

export const MFA_TYPE = { SMS: "sms", EMAIL: "email" };

export const FUNCTIONAL_ROLES_CONSTANTS = Object.freeze({
    account_manager_internal: {
      label: 'Account Manager',
      value: 'account_manager_internal'
    },
    head_of_sales_internal: {
      label: 'Head of Sales',
      value: 'head_of_sales_internal'
    },
    commercial_manager_internal: {
      label: 'Commercial Manager',
      value: 'commercial_manager_internal'
    },
    head_of_commercial_internal: {
      label: 'Head of Commercial',
      value: 'head_of_commercial_internal'
    },
    engineering_or_technology_internal: {
      label: 'Engineering/Technology',
      value: 'engineering_or_technology_internal'
    },
    billing_operations_internal: {
      label: 'Billing Operations',
      value: 'billing_operations_internal'
    },
    operations_internal: {
      label: 'Operations',
      value: 'operations_internal'
    },
    marketing_internal: {
      label: 'Marketing',
      value: 'marketing_internal'
    },
    regulatory_internal: {
      label: 'Regulatory',
      value: 'regulatory_internal'
    },
    service_manager_internal: {
      label: 'Service Manager',
      value: 'service_manager_internal'
    },
    super_admin_internal: {
      label: 'Super Admin',
      value: 'super_admin_internal'
    },
    product_internal: {
      label: 'Product Team',
      value: 'product_internal'
    }
  });

  export const getInsightPath = () => {
    if (CAN(Action.GET, Resource.WEATHERMAPS)) {
      return {
        path: "/insights/ipLinkUtilization",
        navigate: <Navigate to="ipLinkUtilization" />
      };
    } else if (CAN(Action.GET, Resource.DIAMETER)) {
      return {
        path: "/insights/diameter",
        navigate: <Navigate to="diameter" />
      };
    }else if (CAN(Action.GET, Resource.SIGTRAN)) {
      return {
        path: "/insights/sigtran",
        navigate: <Navigate to="sigtran" />
      };
    }
    return null;
  };

  export const getConnectivityPath = () => {
    if (CAN(Action.LIST, Resource.LIVE_SERVICES)) {
      return {
        path: "/connectivity/liveServices",
        navigate: <Navigate to="liveServices" />
      };
    } else if (CAN(Action.GET, Resource.DEMANDS)) {
      return {
        path: "/connectivity/demands",
        navigate: <Navigate to="demands" />
      };
    }
    return null;
  };

  export const getIncidentManagementPath = () => {
    if (CAN(Action.LIST, Resource.INCIDENTS)) {
      return {
        path: "/incident-management/incidents",
        navigate: <Navigate to="incidents" />
      };
    } else if (CAN(Action.LIST, Resource.SERVICE_REQUESTS)) {
      return {
        path: "/incident-management/serviceRequests",
        navigate: <Navigate to="serviceRequests" />
      };
    }
    return null;
  };

  export const getUserManagementPath = (myRights) => {
    if (CAN(Action.LIST, Resource.CUSTOMERS)) {
      return {
        path: "/user-management/customers",
        navigate: <Navigate to="customers" />
      };
    }
    if (CAN(Action.LIST, Resource.CUSTOMER_ONBOARDING_REQUEST)) {
      return {
        path: "/user-management/onboardingRequests",
        navigate: <Navigate to="onboardingRequests" />
      };
    }
    if (CAN(Action.LIST, Resource.CUSTOMER_ACCESS_APPROVAL) && myRights?.functionalRoles[0]!=="super_admin_internal") {
      return {
        path: "/user-management/onboardingApprovals",
        navigate: <Navigate to="onboardingApprovals" />
      };
    }
    if (CAN(Action.LIST, Resource.RIGHTS) && myRights?.functionalRoles[0]=="super_admin_internal") {
      return {
        path: "/user-management/vodafoneUsers",
        navigate: <Navigate to="vodafoneUsers" />
      };
    }
    return null;
  };
  